import { GothamSSm } from '../../fonts/GothamSSm/index.js';

var fonts = {
  GothamSSm: GothamSSm // MillerText | Georgia (| Lobster)

};

export { fonts };
//# sourceMappingURL=fonts.js.map
